import React, { useEffect, useState } from "react";
import { RiArrowUpDownLine, RiCheckFill, RiSearchLine } from "@remixicon/react";
import classNames from "classnames";
import { User } from "../../../__generated__/api";
import Styles from "./UserList.module.scss";
import Confirm from "../../confirm/Confirm";
import { UserDetails } from "../../user-overlay/UserOverlay";
import UserDisplay from "../labels/user/User";
import Button from "../../theme/button/Button";
import FormGroup from "../../theme/form-group/FormGroup";
import { useDebounce } from "../../../debouncer";
import { LoggingHandler } from "../../../contexts/logging/LoggingContext";

enum SortDirection {
    Ascending = 1,
    Descending = -1
}
export default function UserList({
    users,
    shouldShow,
    title,
    onHide,
    metricPathPrefix,
}: {
    users: User[];
    shouldShow: boolean;
    onHide: () => void;
    title: string;
    metricPathPrefix: string[];
}) {
    const [selectedUser, setSelecteDUser] = useState<User>(users.firstElement);
    const [search, setSearch] = useState("");
    const [sortDirection, setSortDirection] = useState(SortDirection.Ascending);

    useEffect(() => {
        setSelecteDUser(users.firstElement);
    }, [users]);

    const debounce = useDebounce(() => {
        LoggingHandler.instance.metric([...metricPathPrefix, "search"]);
    }, 500, metricPathPrefix);

    let visibleUsers = users;
    if (search) {
        const searchFilter = search.toLowerCase();
        visibleUsers = visibleUsers.filter(user => user.name?.toLowerCase().includes(searchFilter)
            || user.group?.toLowerCase().includes(searchFilter)
            || user.handles?.some(handle => handle.email?.email?.toLowerCase().includes(searchFilter)));
    }
    visibleUsers = sortDirection === SortDirection.Ascending
        ? visibleUsers.sortBy(user => user.name)
        : visibleUsers.sortByDescending(user => user.name);

    return (
        <Confirm
            bodyClassName={Styles["user-list-modal"]}
            shouldShow={shouldShow}
            title={title}
            size="lg"
            onHide={onHide}
            shouldShowFooter={false}
        >
            <div className={Styles["user-list"]}>
                <div className={Styles.list}>
                    <div className={Styles["search-line"]}>
                        <FormGroup
                            type="search"
                            size="filter"
                            placeholder="Search"
                            variant="default"
                            className={Styles.search}
                            prefixIcon={<RiSearchLine />}
                            onChange={evt => {
                                setSearch(evt.target.value);
                                if (evt.target.value) {
                                    debounce();
                                }
                            }}
                            value={search}
                        />
                        <Button
                            size="small"
                            variant="secondary"
                            prefixIcon={<RiArrowUpDownLine />}
                            onClick={() => setSortDirection(sortDirection === SortDirection.Ascending
                                ? SortDirection.Descending
                                : SortDirection.Ascending)}
                        />
                    </div>
                    <div className={Styles["results-list"]}>
                        {visibleUsers.map(user => (
                            <Button
                                key={user.id}
                                variant="none"
                                className={classNames(
                                    Styles["user-row"],
                                    user.id === selectedUser?.id ? "active" : "",
                                )}
                                onClick={() => setSelecteDUser(user)}
                                metricPath={metricPathPrefix ? [...metricPathPrefix, "click"] : undefined}
                            >
                                <div className="user-name">
                                    <UserDisplay metricPathPrefix={metricPathPrefix} user={user} allowOverlay={false} />
                                </div>
                                {user.id === selectedUser?.id && (
                                    <RiCheckFill />
                                )}

                            </Button>
                        ))}
                    </div>
                </div>
                <UserDetails metricPathPrefix={metricPathPrefix} user={selectedUser} className={Styles["user-view"]} />
            </div>
        </Confirm>
    );
}
